import React from "react";
import { supabase } from "../supabase";
import { cacheGuideTimeline, getCachedGuideTimeline } from "../dbSafe";

export function useGuideTimeline({ arrangementId }) {
  const [timeline, setTimeline] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    let mounted = true;

    if (!arrangementId) {
      setTimeline(null);
      setError("");
      setLoading(false);
      return () => {
        mounted = false;
      };
    }

    const load = async () => {
      setLoading(true);
      setError("");

      const cached = await getCachedGuideTimeline(arrangementId);
      if (mounted && cached) {
        setTimeline(cached);
      }

      try {
        const { data, error: rpcError } = await supabase.rpc("build_guide_timeline", {
          p_arrangement_id: arrangementId,
        });

        if (rpcError) throw rpcError;
        if (!mounted) return;
        if (data) {
          setTimeline(data);
          await cacheGuideTimeline(arrangementId, data);
          if (data.ok === false) {
            setError(data.error || "Guide timeline unavailable");
          }
        }
      } catch (err) {
        if (!mounted) return;
        if (!cached) {
          setError(err.message || "Failed to load guide timeline");
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    load();

    return () => {
      mounted = false;
    };
  }, [arrangementId]);

  const ok = timeline ? timeline.ok !== false : true;
  const hasStems = timeline ? timeline.has_stems ?? timeline.hasStems ?? null : null;

  return {
    timeline,
    ok,
    hasStems,
    loading,
    error,
  };
}

export default useGuideTimeline;
